import { Row } from 'antd';
import styled from '@emotion/styled';

const StyledInfo = styled(Row)`
  min-height: 35px;
  > div {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.002em;
    text-align: left;
  }
  > div:first-of-type {
    color: rgba(137, 145, 160, 1);
  }
  > div:last-child {
    color: rgba(35, 43, 58, 1);
  }
`;
export default StyledInfo;
